import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "octagon",
  "use": "octagon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"octagon\">\n<path d=\"M16.1,23H7.9c-0.3,0-0.5-0.1-0.7-0.3l-5.9-5.9C1.1,16.7,1,16.4,1,16.1V7.9c0-0.3,0.1-0.5,0.3-0.7l5.9-5.9\n\tC7.3,1.1,7.6,1,7.9,1h8.3c0.3,0,0.5,0.1,0.7,0.3l5.9,5.9C22.9,7.3,23,7.6,23,7.9v8.3c0,0.3-0.1,0.5-0.3,0.7l-5.9,5.9\n\tC16.7,22.9,16.4,23,16.1,23z M8.3,21h7.5l5.3-5.3V8.3L15.7,3H8.3L3,8.3v7.5L8.3,21z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol